<script>
import SlideUpload from './SlideUpload.vue';
import { cleanSASUrl } from './Editor/memoryshare/tributeAssetFactory.js';
const MAX_VIDEO_SIZE = 2 * 1024 * 1024 * 1024; // 2GB
const MAX_IMAGE_SIZE = 40 * 1024 * 1024; // 40MB

export default {
    extends: SlideUpload,
    // You can add or override options here
    // data() {
    //     return {
    //     };
    // },
    created() {
        console.log('Hello from extended SlideUpload, TributeAssetUpload.vue');
    },
    methods: {
        async getUploadUrl(eventId, file) {
            try {
                return await this.apiService.tributePhoto.getUploadUrlForTributeEventEditorAsset(eventId, file.name);
            } catch (error) {
                console.log(error, 'error');
            }
        },
        async onFileAdded(file) {
            const isImage = file.type.startsWith('image/');
            const isVideo = file.type.startsWith('video/');
            const uppy = this.uppy;
            let maxSize = isImage ? MAX_IMAGE_SIZE : isVideo ? MAX_VIDEO_SIZE : MAX_IMAGE_SIZE,
                height,
                width,
                duration,
                fileTypeLabel;
            console.log('file-added on tribute asset upload', file);
            if (file.size > maxSize) {
                const maxSizeMB = maxSize / (1024 * 1024);
                const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);

                uppy.removeFile(file.id);
                this.showSnackbar({
                    message: `${fileTypeLabel} file "${file.name}" (${fileSizeMB}MB) exceeds the maximum size limit of ${maxSizeMB}MB`,
                    color: 'error',
                });

                return false;
            }
            const mediaPromise = new Promise(async (resolve, reject) => {
                if (isImage) {
                    const url = URL.createObjectURL(file.data);
                    const image = new Image();
                    image.src = url;
                    image.onload = () => {
                        width = image.width;
                        height = image.height;
                        file.meta.height = height;
                        file.meta.width = width;
                        
                        uppy.setFileMeta(file.id, { width, height });
                        URL.revokeObjectURL(url);
                    };
                    fileTypeLabel = 'Image';
                    resolve()
                } else if (isVideo) {
                    fileTypeLabel = 'Video';
                    const url = URL.createObjectURL(file.data);
                    const video = document.createElement('video');
                    video.onloadedmetadata = function (event) {
                        console.log('video metadata loaded', video, event);
                        // retrieve dimensions
                        height = this.videoHeight;
                        width = this.videoWidth;
                        duration = this.duration;
                        file.meta.height = height;
                        file.meta.width = width;
                        file.meta.duration = duration;

                        uppy.setFileMeta(file.id, { width, height, duration });
                        URL.revokeObjectURL(url);
                        resolve(); 
                    }
                    video.src = url;
                } else {
                    fileTypeLabel = 'File';
                    resolve();
                }
            });
            mediaPromise.then(async () => {
                if (this.maxFiles === 1) {
                    await this.reset();
                    this.tempFiles = [file];
                } else {
                    this.tempFiles = [...this.tempFiles, file];
                }
                this.$emit('filesAdded', file);
            })
        },
        getAllowedFilesTypes() {
            // imgly kinda throws a fit if the baseUrl media isn't a video so...
            let allowedFileTypes = ['.mp4', '.mov'];

            return allowedFileTypes;
        },
        async initUpload(eventId) {
            console.log('initUpload from extended SlideUpload', eventId);
            
            try {
                
                if (!eventId || eventId <= 0) {
                    throw new Error('Invalid eventId');
                }
    
                const files = this.tempFiles;
                const totalFiles = files.length;
                this.$store.dispatch('tributeVideo/updateTributeVideo', {
                    incomingUploadCount: totalFiles,
                    ingestPipelineCount: totalFiles,
                });
    
                const batchedFiles = this.chunkArray(files, this.batchSize);
    
                if (files.length === 0) {
                    throw new Error('No files found');
                }

                const cancelTokenSource = this.axios.CancelToken.source();
                this.loading = true;
                this.uploadedBytes = 0;
                this.totalBytes = files.reduce((acc, file) => acc + file.size, 0);

                let uploadResponse;

                let successfulUploads = [];

                for (const batch of batchedFiles) {
                    uploadResponse = await this.processFileBatch(eventId, batch, cancelTokenSource.token);
                    successfulUploads = successfulUploads.concat(uploadResponse);
                    this.$emit('successful-uploads', uploadResponse);

                    this.$store.dispatch('tributeVideo/updateTributeVideo', {
                        incomingUploadCount: Math.max(totalFiles - successfulUploads.length, 0),
                    });
                }

                uploadResponse = successfulUploads;
                return uploadResponse;
            } catch (error) {
                this.showSnackbar({ message: error.message, color: 'error' });
                console.error('Error uploading files', error);
                this.$store.dispatch('tributeVideo/updateTributeVideo', {
                    incomingUploadCount: 0,
                    ingestPipelineCount: 0,
                });
            } finally {
                await this.reset();
                this.loading = false;
            }
        },
        async processFileBatch(eventId, files, cancelToken) {
            console.log(eventId, files);

            try {
                const uploadResults = await Promise.allSettled(
                    files.map(file => this.processSingleFileAzureUpload(eventId, file, cancelToken)),
                );

                const enrichedUploadResults = uploadResults.map((result, index) => ({
                    ...result,

                    uppyId: files[index].id, // Assuming each file object has an 'uppyId' property
                }));

                const successfulUploads = uploadResults
                    .filter(result => result.status === 'fulfilled')
                    .map((result, index) => {
                        const { value } = result;
                        const mediaResult = {
                            url: value.url,
                            name: value.name,
                            height: files[index]?.meta?.height,
                            width: files[index]?.meta?.width,
                        };
                        if (files[index]?.meta?.duration) {
                            mediaResult.duration = files[index].meta.duration;
                        }

                        return mediaResult;
                    });
                const { data: dbResponse } = await this.apiService.tributePhoto.postTributeEventEditorAsset(eventId, successfulUploads);
                
                const response = enrichedUploadResults
                    .filter(result => result.status === 'fulfilled')
                    .map(result => ({
                        dbData: dbResponse.find(dbItem => dbItem.url === result.value.url),
                        uppyId: result.uppyId,
                    }));

                return response;
            } catch (error) {
                console.error('Error during batch file process', error);
            }
        },
    },
};
</script>
